<template>
  <router-link
    class="event-link"
    :to="{ name: where, params: { trackid: institution.track_id,  insti : institution.short_name } }"
  >
    <div class="event-card -shadow p-2 m-2">
      <h4 class="title mt-1">
        {{ institution.name }} ({{ institution.short_name }})
      </h4>
      <span class="eyebrow">{{ institution.category }}</span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ["institution", "where"]
};
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.event-card {
  transition: all 0.2s linear;
  cursor: pointer;
  background-color: lightgray;
  border-radius: 10px 10px;
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}

.event-link {
  color: black;
  text-decoration: none;
}
</style>
